import React, {useRef, useState, useEffect  } from "react";
import {Link, useLocation} from "react-router-dom";
import Pages from "../LanguagePage";
import Modal from 'react-bootstrap/Modal'
import nodata from '../../Layout/imgs/nodata0.png';
import Timer from "../../pageInside/timer";
import {authenticate, UserAgree, UserStepUP } from "../../auth";
import "../../pages/addProduct.css" 

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const isNullOrEmpty = (value)=> {
    // Check for null, undefined, or false
    if (value == null || value === false || value === undefined) return true;
  
    // Check if the value is an empty object or array
    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }
    // Otherwise, return false (the value is neither null, undefined, false, nor empty)
    return false;
  }
const  UserExitActAss = (props) => {

    const {
        showProposition,
        setShowProposition,
        infoSource,
        token,
        userActiveRole,
        ActiveAgree = false
    }= props

    let BnPlanAffaire = {
        planAffaire : true,
        termCondition: false,
        userAgree: false
    }
    let bnTermCondition ={
    planAffaire : false,
    termCondition: true,
    userAgree: false
    }

    let bnUserAgree ={
    planAffaire : false,
    termCondition: false,
    userAgree: true
    }

    // const {
    //     customer,
    //     seller,
    //     provider,
    //     userid,
    //     role,
    //     roleName,
    //     level,
    //     maxRoyalite,
    //     maxSeller,
    //     maxProducer,
    //     maxAssociate,
    //     maxInvestment,
    //     maxAdmin,
    //     userAdmin,
    //     Admintean,
    //     // experyDate,
    // } = userActiveRole

    const { 
        roleName,
        level,
        experyDate 
        } =  !isNullOrEmpty(userActiveRole.userActiveRole) ? userActiveRole.userActiveRole : userActiveRole

      const location = useLocation(); // Surveille les changements d'URL
      const query = useQuery();
      const getPageBoo = (rol) => {
                    
        const role = query.get("r") || rol;
        return role
    };

    const [pages, setPages]= useState(BnPlanAffaire)
    const prevSearchRef = useRef(location.search);
    const [userLeve, getUserleve] = useState(level)
    const [interesting, setInteresting] = useState(false);
    const [interestingAgree, setInterestingAgree] = useState(false);
    const [planAfCh, setPlanAfCh] = useState(false);
    const [ternConCh, setTernConCh] = useState(false);
    const [agreeCh, setAgreeCh] = useState(false);
    const [roleNamePage, setRoleNamePage] = useState({
        plan: '',
        term:'',
        agree:'',
        roleNameSel: roleName? roleName : 'Royalty'  
    });

    let userRolle = [
        {name: 'Royalty', leve: 1}, 
        {name: 'Seller', leve: 2}, 
        {name: 'Provider', leve: 3},
        {name: 'Associate', leve: 4},
        {name: 'Investment', leve: 5}, 
        {name: 'Administrator', leve: 6},
        {name: 'Family', leve: 7}]

        const handleUserRole =()=> event =>{
            let userRole = event.target.value;
            chosingRolePage(userRole)
        }
        const checkObjEmpty =(obj)=>{
            if(Object.values(obj ? obj: []).length > 0){
                
                return true
            }else {
                // setMessageExp(true)
                return false
            }
            
            }

            const {
                plan,
                term,
                agree,
                roleNameSel
            } = roleNamePage

    const {
        planAffaire,
        termCondition,
        userAgree,
        } = pages


        const chosingRolePage =(a)=>{
            setPages(BnPlanAffaire)
            if(a === 'Royalty'){
                setRoleNamePage({
                    plan: 'planUserRoyal',
                    term:'termConditionRoyal',
                    agree:'royalAgree',
                    roleNameSel: a
                })
            }else if(a === 'Seller'){
                setRoleNamePage({
                    plan: 'planUserSeller',
                    term: 'termConditionSeller',
                    agree: 'sellerAgree',
                    roleNameSel: a
                })
            }else if(a === 'Provider'){
                setRoleNamePage({
                    plan: 'planUserProvider',
                    term: 'termConditionProvider',
                    agree: 'providerAgree',
                    roleNameSel: a
                })
            }else if(a === 'Associate'){
                setRoleNamePage({
                    plan: 'planAffaireElakay',
                    term:'termConditionAssociate',
                    agree:'associateAgree',
                    roleNameSel: a
                })
            }else if(a === 'Investment'){
                setRoleNamePage({
                    plan: 'planProInvestElakay',
                    term:'termConditionInvest',
                    agree:'investmentAgree',
                    roleNameSel: a
                })
            }else if(a === 'Administrator'){
                setRoleNamePage({
                    plan: 'planProAdminElakay',
                    term:'termConditionAdmin',
                    agree:'AdministratorAgree',
                    roleNameSel: a
                })
            }else if(a ==='Family'){
                setRoleNamePage({
                    plan: 'planAffaireFamily',
                    term:'termConditionFamily',
                    agree:'familyAgree',
                    roleNameSel: a
                })
            }

        }
    const divInfoRoll = useRef(null);
        
        const scrollToParagraph = (ref) => {
                ref.current.scrollIntoView({ behavior: 'smooth' });
              };

        useEffect(() => {
  // Exécute uniquement si la recherche a changé depuis la dernière fois
  if (prevSearchRef.current !== roleNameSel) {
    // Met à jour la page en fonction du rôle
    const targetPage = getPageBoo(roleNameSel);
    chosingRolePage(targetPage);
    
    // Met à jour la référence pour la prochaine comparaison
    prevSearchRef.current = roleNameSel;
  }
}, [roleNameSel]);



    const checkProdKeyExit = (ad)=>{
        let ent 
        if(Array.isArray(ad)){
          let ac = ad[0]
          ent = Object.keys(ac ? ac:{});
          return ent.every(([key, val]) => ac[key] != undefined) && true
        } else{
           ent = Object.keys(ad ? ad:{});
           return ent.every(([key, val]) => ad[key] != undefined) && true
        }}
     
        // const clickAgree = () => {
        //     UserAgree(token).then(data => {
        //         if (data.error) {
        //             console.log(data.error)
        //         } else {
        //             authenticate(data, () => { 
        //               // create a page show them the new fuction they have link to page
        //                 var redirectToURL = '/your-step';
        //                 window.location.href = redirectToURL;      
        //             });
        //         }
        //     })
        // }

    //     const clickAgree = () => {
    //         UserStepUP(token, {customer, seller, provider, userid, role, roleName, level, maxRoyalite, maxSeller, maxProducer, maxAssociate, maxInvestment, maxAdmin, userAdmin, Admintean, agreeRole: true}).then(data => {
    //            if (data.error) {
    //                console.log(data.error)
    //            } else {
    //                authenticate(data, () => { 
    //                  // create a page show them the new fuction they have link to page
    //                    var redirectToURL = '/';
    //                    window.location.href = redirectToURL;      
    //                });
    //            }
    //        })
    //    }

        const clickAgree = (data) => {
             UserStepUP(token, data).then(data => {
                if (data.error) {
                    console.log(data.error)
                } else {
                    authenticate(data, () => { 
                      // create a page show them the new fuction they have link to page
                        var redirectToURL = '/';
                        window.location.href = redirectToURL;      
                    });
                }
            })
        }

    const pageSteps = (a)=>{
        if (!checkProdKeyExit(a)){
           return <Pages  
           classAlert ={'container'}
            paragra0={a}
        />
        }else{
          return <div> 
          <div className="row mt-4 mb-4 justify-content-center">
            <div className="col-11">
          <img className="shadow-lg" style={{ width: "100%" }} src={nodata} alt="firt Step" />
           </div>
           </div></div>
        }
    }

    const bonPrev = (a)=>{
        return  <button onClick={()=> {setPages(a); scrollToParagraph(divInfoRoll)}} className="btn btn-primary p-2 float-left" style={{ width: "120px" }}>
          {infoSource.laguangeElakay('Button', infoSource.languageAPI).previous}
        </button>
      }
     const  bonNext = (a, t = true)=>{
         return <button onClick={()=> {setPages(a); scrollToParagraph(divInfoRoll)}} className="btn btn-primary p-2 float-right" style={{ width: "120px" }}>
          {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
       </button>
      }

      const allBon = (p, n, t)=>{
          return  <div className="row justify-content-center m-4">
          <div className="col col-sm-10">
              <div className="bg clearfix ">
                  { p && bonPrev(p)}
                  {n && bonNext(n, t)}
              </div>
          </div></div>
      }
      const  sendCodeBnt = ()=>{
        let newData = userActiveRole.userActiveRole
            newData['agreeRole']= true
        return planAfCh && ternConCh && agreeCh ? 
        <button onClick={()=> clickAgree(newData)} className="btn btn-primary p-2 float-right" style={{ width: "120px" }}>
        {/* active user */}
        {infoSource.language(infoSource, "Button", "actUser")} 
      </button> : <button className="btn btn-primary p-2 float-right disabled" style={{ width: "120px" }}>
      {/* active user */}
      {infoSource.language(infoSource, "Button", "actUser")} 
      </button>
     }


     const  BtnNotIntereting = ()=>{
        let newData = Object.fromEntries(
            Object.entries(userActiveRole).filter(([key]) => key !== 'userActiveRole')
          )
        return interesting && interestingAgree ? 
        <>
        <button onClick={()=> clickAgree(newData)} className="btn btn-primary p-2 float-right" style={{ width: "120px" }}>
        {/* active user */}
        {infoSource.language(infoSource, "Button", "submit")} 
      </button> </>: <button className="btn btn-primary p-2 float-right disabled" style={{ width: "120px" }}>
      {/* active user */}
      {infoSource.language(infoSource, "Button", "submit")} 
      </button>
     }

     const  CheckBoxButton = ()=>{
        let c = planAfCh? false: true
        setPlanAfCh(c) 
        setInteresting(false)
        setInterestingAgree(false)

     }
     const  CheckInteresting = ()=>{
        setInteresting(!interesting)
        setPlanAfCh(false) 
        setTernConCh(false) 
        setAgreeCh(false)
     }
     const  CheckInterestingAgree = ()=>{
        setInterestingAgree(!interestingAgree)
        setPlanAfCh(false) 
        setTernConCh(false) 
        setAgreeCh(false)
     }
     const  CheckBoxButton0 = ()=>{
        let c = ternConCh? false: true
        setTernConCh(c) 
        setInteresting(false)
        setInterestingAgree(false)
     }
     const  CheckBoxButton1 = ()=>{
        let c = agreeCh? false: true
        setAgreeCh(c) 
        setInteresting(false)
        setInterestingAgree(false)
     }
      

    const  planAffairePage =()=>{
        return planAffaire && <div ref={divInfoRoll}>
            {pageSteps(infoSource.laguangeElakay(plan,  infoSource.languageAPI))}
            {  allBon(undefined, bnTermCondition)}
            </div> 
    }   

    const  termConditionPage =()=>{
        return termCondition && <div ref={divInfoRoll}>
               {pageSteps(infoSource.laguangeElakay(term,  infoSource.languageAPI))}
           
            {  allBon(BnPlanAffaire, bnUserAgree)}
            </div> 
    }



    const userAgreePage =()=>{
        return userAgree && <div ref={divInfoRoll}>
            {pageSteps(infoSource.laguangeElakay(agree,  infoSource.languageAPI))}
            <div className="container">
            <div className="row mb-4 justify-content-center">
            <ul className="col-12 col-md-9">
                <li className="list-unstyled"> 
                    <input
                            onChange={()=> CheckInteresting()}
                            type="checkbox"
                            className="form-check-input"
                            checked={interesting ? 'checked' : ''}
                            id="notInterested"
                        />
                        <label className="form-check-label" for="notInterested">
                            {/* es ce que vous avez lu le plan d'affaire  */}
                            {infoSource.language(infoSource, "label", "notInterested")}
                            </label>
                           { interesting  &&  <ul className="col-12 col-md-9">
                             <li className="list-unstyled">
                             <input
                            onChange={()=> CheckInterestingAgree()}
                            type="checkbox"
                            className="form-check-input"
                            checked={interestingAgree ? 'checked' : ''}
                            id="notInterestedAgree"
                        />
                        <label className="form-check-label" for="notInterestedAgree">
                            {/* es ce que vous avez lu le plan d'affaire  */}
                            {infoSource.language(infoSource, "title", "chButAgree")}
                            </label>
                           </li>
                           { BtnNotIntereting()}
                           </ul> }       
                    </li>
                    </ul>
            <ul className="col-12 col-md-9">
            
                    <li className="list-unstyled"> 
                    <input
                            onChange={CheckBoxButton}
                            type="checkbox"
                            className="form-check-input"
                            checked={ !ActiveAgree ? 'checked' : planAfCh ? 'checked' : ''}
                            id="planAffairLu"
                        />
                        <label className="form-check-label" for="planAffairLu">
                            {/* es ce que vous avez lu le plan d'affaire  */}
                            {infoSource.language(infoSource, "label", "planAffairLu")}
                            </label>
                    </li>
                    <li className="list-unstyled">
                    <input
                            onChange={CheckBoxButton0}
                            type="checkbox"
                            className="form-check-input"
                            checked={!ActiveAgree ? 'checked' : ternConCh? 'checked' : ''}
                            id="termConditionAgre"
                        />
                        <label className="form-check-label" for="termConditionAgre">
                            {/* es ce que vous ete d'acord avec les term et les condition */}
                            {infoSource.language(infoSource, "label", "termConditionAgre")}
                            </label>
                    </li>
                    <li className="list-unstyled">
                        <input
                            onChange={CheckBoxButton1}
                            type="checkbox"
                            className="form-check-input"
                            checked={!ActiveAgree ? 'checked' : agreeCh? 'checked' : ''}
                            id="acpContinue"
                        />
                        <label className="form-check-label" for="acpContinue">
                        {infoSource.language(infoSource, "title", "chButAgree")}
                             {/* avec le deux volet pour continue */}
                             {infoSource.language(infoSource, "label", "acpContinue")}
                             </label>
                    </li>
                </ul>
                
            </div>
            { ActiveAgree && sendCodeBnt()}
            </div>
            {  allBon(bnTermCondition, undefined)}
            </div> 
    }

    let plsh = planAffaire || termCondition || userAgree ? "active" : ''
    let tcsh = termCondition || userAgree ? "active" : ''
    let Agsh = userAgree ? "active" : ''

    const stepSeller = ()=>(
   <div className="row justify-content-center mt-4">
  <div className="col-xs-12 col-md-8">
    <div className="wrapper-progressBar">
        
   {<select value={roleNameSel} onChange={handleUserRole()} className="form-select" aria-label="Default select example">
  {userRolle.filter(item =>item.leve <= userLeve).map((s, i)=>{
   return <option value={s.name}>{s.name}</option>
  })}
</select>}


      <ul className="progressBar1 mt-4">
        <li className={plsh} onClick={()=> setPages(BnPlanAffaire)}>
            {/* Plan D'affaire */}
            {infoSource.language(infoSource, "label", "planAffai")}
            </li>
        <li className={tcsh}  onClick={()=> setPages(bnTermCondition)}>
            {/* Term & Condition */}
            {infoSource.language(infoSource, "label", "termCondi")}
            </li>
        <li className={Agsh} onClick={()=> setPages(bnUserAgree)}>
            {/* Final Agree */}
            {infoSource.language(infoSource, "label", "FinalAgree")}
            </li>
      </ul>
    </div>
  </div>
</div>
    )


const allform =()=>{
    return <div className="row mt-4 mb-4 justify-content-center">
    <div  className="col col-12 col-md-12 col-lg-12 col-xl-11 p-0">
                 <Timer
                    infoSource={infoSource}
                    nbrdays = {experyDate - new Date()} 
                    enDate={experyDate}
                    /> 
                {planAffairePage()}
                {termConditionPage()}
                {userAgreePage()}
                 </div>
                 </div>
            
            }

return  <div className="contaire">
            <Modal
                size="xl"
                show={showProposition}
                onHide={() => setShowProposition(false)}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                centered
            >
                  <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                    <h2>{infoSource.language(infoSource, "label", "allKnowAbout")} {' '} {roleNameSel} </h2>
                    </Modal.Title>
                </Modal.Header>
            <Modal.Body>
               
                    {stepSeller()} 
                    {allform()}

                    </Modal.Body>
            </Modal>
        </div>

}

    export default  UserExitActAss ;